<template>
  <div class="xcbdMorecls">
    <van-tabs v-model="activeName" swipeable @click="tabsClickFn">
      <van-tab
        :title="item.label"
        v-for="(item, index) in navTitle"
        :key="index"
        :name="navTitle.id"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="newsPanel"
            v-for="(item2, index2) in navContentList"
            :key="index2"
            @click="detail"
          >
            <div class=" newsContentBox flex">
              <div>
                <div>{{ item2.value1 }}</div>
                <p>{{ item2.value2 }}</p>
                <p>{{ item2.value3 }}</p>
              </div>
              <div>
                <img src="@/assets/picture/111.png" width="100%" alt="" />
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: 'xcbd-more',
  data() {
    return {
      navTitle: [
        { label: '新闻要点', id: 'xwyd' },
        { label: '一线动态', id: 'yxdt' },
        { label: '媒体关注', id: 'mtgz' },
        { label: '一把手谈', id: 'ybst' },
        { label: '"六促六优"先锋榜（第一期）', id: 'dyc' },
        { label: '"六促六优"先锋榜（第二期）', id: 'deq' }
      ],
      activeName: 'xwyd',
      loading: false,
      finished: false,
      navContentList: [
        {
          value1: '区委、开发区党工主题教育读书开班a',
          value2: '记者：刘德华，张晓雪友',
          value3: '2023-9-14'
        }
      ]
    }
  },
  props: {},
  components: {},
  created() {
    console.log(this.$route.query.id)
  },
  mounted() {},
  methods: {
    detail() {
      this.$router.push({
        path: '/xcbdDetail',
        query: {}
      })
    },

    tabsClickFn(name, title) {
      console.log(name)
      console.log(title)
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.navContentList.push({
            value1: '区委、开发区党工主题教育读书开班',
            value2: '记者：刘德华，张晓雪友',
            value3: '2023-9-14'
          })
        }
        // 加载状态结束
        this.loading = false
        // 数据全部加载完成
        if (this.navContentList.length >= 10) {
          this.finished = true
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
.xcbdMorecls {
  height: calc(100% - 60px);
  overflow: auto;
}
.newsPanel {
  color: #000;
  padding: 10px;
  border-bottom: 1px solid #ccc4c4;
}
.newsContentBox {
  height: 100px;
}
.newsContentBox div:nth-child(1) {
  flex: 1;
  text-align: left;
}
.newsContentBox div:nth-child(1) div {
  height: 40%;
  width: 100%;
  margin-bottom: 30px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.newsContentBox div:nth-child(1) p {
  font-size: 12px;
  color: #999;
}
.newsContentBox div:nth-child(2) {
  width: 100px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/xcbd-more.vue